import Map from './map';

class MapHome extends Map {
  constructor() {
    super();

    this.dom.map = document.querySelector('.js-map-home');
    this.dom.mapEl = this.dom.map.querySelector('.js-map-el');
    this.dom.zoomIn = this.dom.map.querySelector('.js-zoom-in');
    this.dom.zoomOut = this.dom.map.querySelector('.js-zoom-out');

    this.bounds = null;
  }

  setBounds = () => {
    this.bounds = new window.google.maps.LatLngBounds();

    [...this.markers].forEach((marker) => {
      this.bounds.extend(marker.position);
    });

    // fit markers in map
    this.map.fitBounds(this.bounds);
  }

  zoom = (zoom) => {
    this.state.zoom = zoom;

    this.map.setZoom(zoom);
  }

  listeners = () => {
    this.dom.zoomIn.addEventListener('click', () => this.zoom(this.state.zoom + 1), { passive: true });
    this.dom.zoomOut.addEventListener('click', () => this.zoom(this.state.zoom - 1), { passive: true });
  }

  initMapHome = () => {
    this.init();
    this.initZoom();
    this.setBounds();
    this.listeners();
  }
}

export default MapHome;
